import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/finish-line-video-processing.jpg")